import { Box, Button, MenuItem, Select, Typography } from '@mui/material';
import WalletCardSkeleton from '@efex-components/common/Skeleton/WalletCardSkeleton';
import { useTranslation } from 'react-i18next';
import createNewAccountStyles from './CreateNewAccount.style';
import { CreateNewAccountProps } from './types/CreateNewAccount.types';
import useCreateNewAccount from './hooks/useCreateNewAccount';

const CreateNewAccount = ({
  onChangeSelectedCurrency,
  onClose,
  onGoToNextStep,
}: CreateNewAccountProps) => {
  const { currencyFlag, options, handleChange } = useCreateNewAccount({
    onChangeSelectedCurrency,
  });

  const { t } = useTranslation();

  return (
    <Box className={createNewAccountStyles.wrapper}>
      <Typography variant="h6" align="center">
        {t('createGlobalAccountTitle')}
      </Typography>

      <Box className={createNewAccountStyles.content}>
        <Select
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
          defaultValue={options[0].currency}
          onChange={({ target }) => handleChange(target.value)}
        >
          {options.map((option) => (
            <MenuItem value={option.currency} key={option.currency}>
              {option.currency} - {option.currencyName}
            </MenuItem>
          ))}
        </Select>

        <WalletCardSkeleton currencyImg={currencyFlag} />

        <Box className={createNewAccountStyles.actionsContainer}>
          <Button variant="outlined" onClick={onClose}>
            {t('cancelButton')}
          </Button>

          <Button variant="contained" onClick={onGoToNextStep}>
            {t('createButton')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CreateNewAccount;
